<template>
    <div class="container flex-wrap flex-line">
      <div style="flex-shrink:0;width:140px;height:100%;border-right:1px solid var(--border);overflow-y:auto;"
      >

         <BaseMenu
            :menus="menus"
            :actived="actived"
            @on-click="handleOpen"
        >
        </BaseMenu>
      </div>
      <div style="width:calc(100% - 140px);height:100%;position:relative;">
        <div class="flex-wrap" style="height:60px;padding:0 15px;" v-if="!activedMenu.hideTitle">
          <div>
            <div style="font-size:16px;font-weight:bold;">{{ activedMenu.name }}</div>
            <div style="font-size:12px;color:var(--subtext2)">{{ activedMenu.description }}</div>
          </div>
          <div></div>
          </div>
          <div :style="`height:calc(100% - ${activedMenu.hideTitle ? 0 : 60}px);position:relative;`">

          <router-view></router-view>
          </div>
      </div>
    </div>
  </template>

<script>
import {mapGetters} from 'vuex';
import responsableMixin from '@/mixins/responsable';
export default {
  routerOption: {
    as_default: true,
    as_frame: true,
  },
  mixins: [responsableMixin],
  mounted() {

  },
  computed: {
    ...mapGetters('cm', ['permission']),
    sm() {
      return this.w < 1200;
    },
    activedMenu() {
      return this.menus.find((m)=>m.key == this.actived) || {};
    },
    menus() {
      const items = [
        {
          name: '代理费测算',
          key: 'agency-fee',
          icon: 'md-calculator',
          description: '计价格〔2002〕1980号 · 工程/货物/服务招标代理费',
        },
        {
          name: '造价咨询测算',
          key: 'cost-consulting',
          icon: 'logo-usd',
          description: '浙价服〔2009〕84号 · 浙江造价咨询收费计算器',
        },
        {
          name: '管理监理测算',
          key: 'pm-supervision',
          icon: 'md-construct',
          description: '项目管理及监理费用测算（2018）· 标准收费',
        },
      ];
      return items;
    },
    actived() {
      return this.$route.path.slice(this.$route.path.lastIndexOf('/')+1);
    },

  }, methods: {
    handleOpen(e) {
      this.RouteTo(e);
      localStorage.setItem('cm-route-key', e);
    },
  },
};
</script>

  <style lang="less">
  </style>
